import React, { useState, useEffect } from "react";
import "../App.css";
import "./landing.css";
import "./header.css";
import axios from "axios";
import Header from "./header";
import ReactPlayer from 'react-player';
import { HiOutlineX } from "react-icons/hi";
import { ethers } from "ethers";
import { resources, bgmusic, soundeffects, landingImages, authors, quotes, 
  backgroundImages, contracts } from "../tools/effects";
import { networkDataArray } from "../tools/networkData";
import Brain, { Connector, Mobile, decimals, client, contractsBrain } from "./brain"; 
import Robot from "./robot";
import { fisherYatesShuffle, cacheImage, preloadImages, formatNumber, 
  removeThousands, truncateAddress, copyClipboard } from '../tools/utils';
import { useActiveAccount, useReadContract, useActiveWallet, useActiveWalletChain, 
  useDisconnect, useSwitchActiveWalletChain, useSendTransaction, useWalletBalance, 
  useContractEvents } from "thirdweb/react";
import { createThirdwebClient, getContract, sendTransaction, readContract, prepareContractCall, prepareEvent, numberToBytes} from "thirdweb";
import { useDispatch, useSelector } from 'react-redux';
import { defineChain } from "thirdweb/chains";
import { updateNetworkIndex, fetchNetworkData } from '../redux/actions/networkActions';
import { selectNetworkIndex, selectBlockchain, chains } from '../redux/reducers/networkReducer';

// Global Constants *************************************************************************************************************** 
let isAT = null, wallet, account, isACID;

function chainSelector () {
  const cachedCounter = localStorage.getItem('networkCounter');
  if (cachedCounter !== null && !isNaN(parseInt(cachedCounter))) {
    return parseInt(cachedCounter);
  }    
  return 0;
}

function Landing() { 
  wallet = useActiveWallet();  
  account = useActiveAccount();
  const [counter, setCounter] = useState(chainSelector());  
  // Add a useEffect to update localStorage whenever counter changes
  useEffect(() => {
    localStorage.setItem('networkCounter', counter.toString());
  }, [counter]);

  const dispatch = useDispatch();
  const blockchain = useSelector(selectBlockchain);
  const rpcUrl = blockchain.rpc;

  const ecosystemArray = networkDataArray.map(network => network.ecosystem.toLowerCase());
  const pathname = window.location.pathname.toLowerCase();
  const [soundtrack, setSoundtrack] = useState(bgmusic.Soundtrack);
  const [backgroundImage, setBackgroundImage] = useState(0);
  const [audioPlaying, setAudioPlaying] = useState(false);
  const [isEffectPlaying, setIsEffectPlaying] = useState(false);
  const [soundEffectUrl, setSoundEffectUrl] = useState(null);
  const [volumeLevel, setVolumeLevel] = useState(0.1);
  const [submitText, setSubmitText] = useState(null);
  const [component, setComponent] = useState('');
  const [randomAuthor, setRandomAuthor] = useState('');
  const [randomQuote, setRandomQuote] = useState('');
  const disconnect = useDisconnect();
  const [nativeBalance, setNativeBalance] = useState();
  const [isBalanceMode, setIsBalanceMode] = useState(true);
  const { mutate: sendTransaction, data: transactionResult, error: txError } = useSendTransaction();
  const [whitelist, setWhitelist] = useState(null);
  const [participated, setParticipated] = useState(null);
  const [donorList, setDonorList] = useState([]);
  const [inviteLink, setInviteLink] = useState('');
  const [trigger, setTrigger] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [inputValue, setInputValue] = useState(20000);
  const [donation, setDonation] = useState(20000);
  const [loading, setLoading] = useState(false);

  // Contracts **************************************************************************************************************
  // get B.R.A.I.N contract
  let contractBrain = contractsBrain[counter];

  const handleNetworkChange = (_counter) => {
    // Dispatch the fetchNetworkData thunk to update both network index and blockchain data
    dispatch(fetchNetworkData(_counter));
    setCounter(_counter);
  };

  function sendMessage(message) {    
    setSubmitText(message);
    setLoading(true);
    setTimeout(() => {setLoading(false);}, 5000);
  }
  
  const handleInputChange = (e) => {
    const value = e.target.value;
      setInputValue(value);
  }

  const resetVar = () => {
    isAT = null;
    account = null;
    setNativeBalance(null);
  };

  const donateToBrains = () => {
    setPaymentModal(true);
  }

  function payModal() {
    return (
      <div>
        <HiOutlineX className="responder-close-button" onClick={() => setPaymentModal(false)}/>
        <div className="class2">{submitText}</div>
        <input className="inputModal" value={inputValue} onChange={handleInputChange}
          placeholder={`50,000`} type="number"
        />      
        <br/>         
        <button className="ai-button-cyan" onClick={payInBrains}> Donate</button>
      </div>
    );
  }

  async function payInBrains () { 
    if (inputValue < donation) {
      sendMessage(`Minimum contribution is ${formatNumber(donation)} Brains`);
      return;
    } 
    let accbal, value;
    try {
      const call1 = await readContract({
        contract: contractBrain,
        method: "function balanceOf(address account) view returns (uint256)", 
        params: [account.address]
      });
  
      accbal = Number(ethers.utils.formatEther(call1?.toString())); 

      if (accbal > inputValue) {  
        value = inputValue * decimals;
        const transaction = prepareContractCall({
          contract: contractBrain,
          method:
            "function transfer(address to, uint256 value) returns (bool)",
          params: ['0x8B40FC00D483b8A6A31539BbB399B14e1d36E454', value],
        });

        sendTransaction(transaction);
      }
    }  catch (err) {
      console.log('Error fetching Balance.')
    }

  }

  const postDonation =  async () => {
    try {
      const call = await fetch(`https://daemon.brainonsonic.xyz/DONORLIST`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({request: account.address, status: 0}),
      });

      if (call.ok) {
        const callResponse = await call.json();
        console.log("Success! Donor initialized.");
      } else {
        console.log('Failed to initialize donor.');
      }
    } catch (error) {
      console.log('Error initializing donor:', error);
    }
  }

  const fetchDonorList = async () => {
    try {
      const response = await fetch(`https://daemon.brainonsonic.xyz/DONORLIST`, {
        method: "GET",
      });
      if (!response.ok) {
        console.log('Failed to donorlist. Refresh'); 
      }
  
      const donors = await response.json();
      setDonorList(donors);
      const existingDonor = donors.find(donor => donor.OWNERADDRESS === account.address); 
       if (existingDonor) {
          setWhitelist(true);
            if (existingDonor.STATUS > 0) {
              setParticipated(true);
            } else {
              setParticipated(false);
            }
        } else {
          setWhitelist(false); 
          setParticipated(false);
        }
    } catch (error) {
        console.error('Error fetching donor list:', error);
    }
  };

  function donorStatus() {
    return (
      <div className="donor-status">
        We are looking to raise 2 million $BRAINs to market The B.R.A.I.N on Sonic. 
        <br />
        {whitelist && participated === true && (
          <span className="brain-placeholder" style={{ fontSize: '4vh' }}>
          Already Invited.
          </span>
        )}
        {whitelist && participated === false && (
          <>Your donation grants you access to our exclusive All Seeing Lounge. <span style={{ color: 'black' }}>You can only use this invite once. It will expire permanently in 1 hour. Click to copy.</span>
          <span className="invite-link">
          Invite Link <br /> 
          <>
          {!inviteLink ? 
            <span className="brain-placeholder">fetching...</span>
          : 
          <div className="brain-placeholder copyable-text" onClick={() => {copyClipboard(inviteLink)}}>{inviteLink}</div>
          }
          </>
          </span>
          </>
        )}
        {whitelist === false && participated === false && (
          <>
          Donate to gain access to the All Seeing Lounge. <br />Each contribution is one step closer to our goals.
          <div className="invite-link">
            {paymentModal ? 
              <>
               {payModal()}
              </>
            :            
              <button className="ai-button-cyan" onClick={donateToBrains}> Donate </button>
            }
          </div>
          </>
        )}
      </div>
    );
  }

  const generateLink = async () => {
    try {
      const call = await fetch(`https://daemon.brainonsonic.xyz/allseeingeye-link`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({donor: account.address}),
      });

      if (call.ok) {
        const callResponse = await call.json();
        console.log("Response:", callResponse);
        console.log("Link Generated:", callResponse.link.result.invite_link);
        setInviteLink(callResponse.link.result.invite_link);
      } else {
        console.error("Error fetching TG link");
      }

    } catch (error) {
        console.error('Error fetching invite link:', error);
    }
  };

  const summary = () => {    
    if (submitText === 0) return (
      <div className="selection"> 
        <h1 className="title waveanimator liner1"> Business </h1>
          <p className="subtitle waveanimator class2">
            Tailored business strategies for growth with PIA Big Data insights
            <br />
            Streamlined employee efficiency and productivity with PIA Big Data insights
            <br />
            Cutting down on waste and costs with PIA Big Data insights
            <br />
            Improve customer satisfaction with PIA Big Data insights
          </p>
      </div>
    );
    else if ( submitText === 1 ) return (
      <div className="selection"> 
        <h1 className="title waveanimator liner1"> Healthcare </h1>
          <p className="subtitle waveanimator class2">
            Improve your daily fitness routine with PIA Big Data insights
            <br />
            Keep tabs on your personal health with PIA Big Data insights
            <br />
            Record and get a second opinion on each health consultation with PIA Big Data insights
          </p>
      </div>
    );
    else if ( submitText === 2 ) return (
      <div className="selection"> 
          <h1 className="title waveanimator liner1"> Education </h1>
            <p className="subtitle waveanimator class2">
              Improve study assignments with PIA Big Data insights
              <br />
              Curate your own research and thesis with PIA Big Data insights
              <br />
              Estimate and Govern your research expenditure with PIA Big Data insights
            </p>
      </div>
    ); 
    else if (submitText === 3) return ( 
    <div className="selection"> 
      <h1 className="title waveanimator liner1"> Agriculture </h1>
        <p className="subtitle waveanimator class2">
          Oversee your crop yield for small business with PIA Big Data insights
          <br />
          Determine crop health and business viability with PIA Big Data insights
        </p>
    </div>
    );
    else if ( submitText === 4 ) return (
      <div className="selection"> 
          <h1 className="title waveanimator liner1"> Energy </h1>
            <p className="subtitle waveanimator class2">
              Cut down on energy in your business with PIA Big Data insights
              <br />  
              Monitor your energy expenditure with PIA Big Data insights
            </p>
      </div>
    ); 
    else if (submitText === 5) return (
      <div className="selection"> 
        <h1 className="title waveanimator liner1"> Finance </h1> 
          <p className="subtitle waveanimator class2">
            File your digital asset taxes with PIA Big Data insights
            <br />  
            Monitor your financial health with PIA Big Data insights
            <br />  
            Boost your credit score with PIA Big Data insights
          </p>
      </div>
    );
    else if (submitText === 6) return (
    <div className="selection"> 
      <h1 className="title waveanimator liner1"> {randomAuthor} </h1> 
        <p className="subtitle waveanimator class2">
          {randomQuote}
        </p>
    </div>
    );
    else return null;
  }
  
  function NativeBalance() {
    const { data, isLoading, error, refetch } = useReadContract({
      contract: contractBrain,
      method: "function balanceOf(address account) view returns (uint256)", 
      params: [account.address]
    });

    useEffect(() => {
      if (data) {
        isAT = true;
        const localbalance = (Number(data?.toString()) / decimals).toFixed(2);
        setNativeBalance(localbalance);
      }
    }, [account, transactionResult, counter]);

    if (isLoading) return <><span className="layoutBox" >Loading...</span></>;
    if (error) return <><span className="layoutBox" >Error</span></>;

    return (
      <>
        {nativeBalance ? 
          <>          
          {isBalanceMode ? <>{formatNumber(nativeBalance)}</> : <span style={{ letterSpacing: "3px", fontSize: "2vh"}}>BRAINS FOUND</span>}
          </>
          :
          <>
          {isBalanceMode ? <span style={{ letterSpacing: "3px", fontSize: "2vh", color: "red"}}>DENIED</span> : <span style={{ letterSpacing: "3px", fontSize: "2vh"}}>NO BRAINS</span>}
          </>
        }
      </>
    );
  }

  const handlePlay = () => {
    if (audioPlaying) return;
    setAudioPlaying(true);
  };

  const handleControls = () => {
    setAudioPlaying(!audioPlaying);
  };

  const handleSelector = (_index) => {
    setSubmitText(_index);  
    playComplete();
  }
  
  const playSoundEffect = (effect) => {
    setSoundEffectUrl(effect);
    setIsEffectPlaying(true);
  };

  const playComplete = () => {
    playSoundEffect(soundeffects.Complete);
  }

  const playDenied = () => {
    playSoundEffect(soundeffects.Denied);
  }

  const playConfirmation = () => {
    playSoundEffect(soundeffects.Confirmation);
  }

  const playBeep = () => {
    playSoundEffect(soundeffects.Beep);
  }

  const playAccept = () => {
    playSoundEffect(soundeffects.Accept);
  }
  
  const stopSoundEffect = () => {
    setIsEffectPlaying(false);
  };

  let landingBackground = {
    backgroundImage: `url(${backgroundImages[backgroundImage]})`
  };
  
  const loadRobot = () => {
    playAccept();
    setComponent('robot'); 
  }

  const handleBuyGuideComponent = () => {
    playAccept();
    if (component === 'buyguide') {
      setComponent('robot');
    } else {
      setComponent('buyguide');
    }
  }

  const handleRoadmapComponent = () => {
    playAccept();
    if (component === 'roadmap') {
      setComponent('robot');
    } else {
      setComponent('roadmap');
    }
  }
  
  const handleDonorComponent = () => {
    if (!account) return playDenied();
    playAccept();
    if (component === 'donor') {
      setComponent('robot');
      setTrigger(false);
    } else {
      setComponent('donor');
      setTrigger(true);
    }
  }
  
  const [angle, setAngle] = useState(0); // Rotation angle
  const [radius, setRadius] = useState(400); // Radius of the circle
  const speed = 40  // Lower speed by increasing this value

  useEffect(() => {
    // Function to update radius based on screen width
    const updateRadius = () => {
      const isMobile = window.innerWidth <= 768; // Common mobile breakpoint
      setRadius(isMobile ? 250 : 400); // radius for mobile
    };

    // Initial call
    updateRadius();

    // Add event listener for window resize
    window.addEventListener('resize', updateRadius);

    // Interval for rotation
    const interval = setInterval(() => {
      setAngle((prev) => prev + 1);
    }, speed);

    // Cleanup
    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', updateRadius);
    };
  }, []);

  useEffect(() => {
    let timer;
    if (submitText) {
      timer = setTimeout(() => {
        setSubmitText(null);
      }, 6000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [submitText]);

  useEffect(() => {
    const randomIndex = fisherYatesShuffle(authors.length);
  
    setRandomAuthor(authors[randomIndex]);
    setRandomQuote(quotes[randomIndex]);
  }, [submitText]); 

  useEffect(() => {
    const timer = setInterval(() => {
      setIsBalanceMode(prev => !prev);
    }, 12000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (trigger && whitelist && participated === false && !inviteLink && component === 'donor') {
      generateLink();
    }    
  },[trigger]);

  useEffect(() => {
    if (account) {
      fetchDonorList();
      resetVar();      
    }
  },[account]);

  useEffect(() => {
    if (transactionResult && paymentModal) {
      setPaymentModal(false);
      sendMessage("Donated! Refresh for your invite.");
      postDonation();
    }
  },[transactionResult]);
  
  useEffect(() => {  
    if (txError && paymentModal) {
      sendMessage("Payment cancelled! Try again.");
      setPaymentModal(false);
    }
  },[txError]);

  useEffect(() => {
    dispatch(fetchNetworkData(counter));
  }, [dispatch, counter]);

  useEffect(() => { 
    if (pathname) {   
      if (isACID) return;
       isACID = true; 
      for (let i = 0; i < ecosystemArray.length; i++) {
        if (pathname.includes(ecosystemArray[i])) {
          handleNetworkChange(i);
          break;  // Stop after match
        }
      }
      isACID = false;
    }
  },[account]);

  useEffect(() => {
    const fetchParams = async() => {
      try {
        const response = await fetch(`https://daemon.brainonsonic.xyz/assets/docs/log.json`, {
          method: "GET",
        });

        if (!response.ok) throw new Error("Network response was not ok");

        const log = await response.json();

        const params =  log.params[1];
        setDonation(params.donation);
        setInputValue(params.donation);
        
      } catch (error) {
        console.error('Error setting new params:', error);
      }
    }
    fetchParams();
  },[]);

  return (
    <div onClick={handlePlay} className="landing-container" style={landingBackground}>
    <ReactPlayer
      url={soundtrack}
      playing={audioPlaying}
      volume={volumeLevel}
      loop={true}
      style={{ display: "none" }}
      controls={false}
    />   

    <ReactPlayer
        url={soundEffectUrl}
        playing={isEffectPlaying}
        volume={0.8}
        onEnded={stopSoundEffect} 
        style={{ display: 'none' }}
        controls={false}
      />
    <>
      {component === 'roadmap' ? 
        <div className='responder-close-button' style={{color: 'cyan', border: '2px solid cyan'}}>
          <HiOutlineX onClick={handleRoadmapComponent}/>
          <div className="roadmap-container" align="center">
            <img src={require("../assets/images/roadmap.gif")} className="roadmap" />
          </div>
        </div>
      : component === 'donor' ?
      <div className='responder-close-button' style={{color: 'cyan', border: '2px solid cyan'}}>
        <HiOutlineX onClick={handleDonorComponent}/>
          <div className="donor" align="center">
            {donorStatus()}
          </div>
      </div>
      : component === 'buyguide' ? 
      <div className='responder-close-button' style={{color: 'lime', border: '2px solid lime'}}>
        <HiOutlineX onClick={handleBuyGuideComponent}/>
        <div className="roadmap-container">
          <a href="https://app.metropolis.exchange/swap?inputCurrency=S&outputCurrency=0x6f92182a22d76177c98589d65275bb104c81c4e5"  className="buyguide-link" target="_blank" rel="noopener noreferrer">
            <p className="textemphasis header1 buyguideSonic">
              Buy on Metropolis DEX
              <br />
              <div className="illustration">
                <span className="largess cyanflow">1.</span> <img src={require("../assets/images/buy.gif")} className="illustratedImage"/>
              </div>
              <br />
              <div className="smallgess" align="center">CLICK TO BUY</div>
            </p>
          </a>
          <div className="lowerCard">
            <p className="textemphasis header1 buyguideBSC"><span className="">
              For Access on Other chains</span>,<br /> port your $BRAIN with Debridge
              <br />
              <div className="illustration">
                <div className="largess yellowflow">2.</div> <br /> 
                <div>
                  <div>
                    <a href="https://app.debridge.finance/deport?inputChain=146&outputChain=56&inputCurrency=0x6F92182a22D76177C98589D65275Bb104C81C4e5&outputCurrency=0x06cf46F985518085a5dB2b2bf9C06f0906265B33" className="buyguide-link"  target="_blank" rel="noopener noreferrer">
                      <button className="buttonport smallgess bsccolors">
                        <img src={require("../assets/images/1.png")} className="thumbnail"  style={{height: '2vh', width: '2vh'}}/>
                        PORT to BSC</button> 
                    </a>
                    <a href="  https://app.debridge.finance/deport?inputChain=146&outputChain=8453&inputCurrency=0x6F92182a22D76177C98589D65275Bb104C81C4e5&outputCurrency=0x305E970E5E2620aD91DbCAD299cB91840E70bef5" className="buyguide-link"  target="_blank" rel="noopener noreferrer">
                      <button className="buttonport smallgess basecolors" style={{justifyContent: 'center', alignItems: 'center'}}>                    
                        <img src={require("../assets/images/2.png")} className="thumbnail"  style={{height: '2vh', width: '2vh'}}/>
                        PORT to BASE</button> 
                    </a>
                    <a href="https://app.debridge.finance/deport?inputChain=146&outputChain=137&inputCurrency=0x6F92182a22D76177C98589D65275Bb104C81C4e5&outputCurrency=0x06cf46F985518085a5dB2b2bf9C06f0906265B33" className="buyguide-link"  target="_blank" rel="noopener noreferrer">
                      <button className="buttonport smallgess polygoncolors">
                        <img src={require("../assets/images/3.png")} className="thumbnail"  style={{height: '2vh', width: '2vh'}}/>
                        PORT to POLYGON</button> 
                    </a>
                  </div>
                </div>
              </div>
            </p>
          </div>
        </div>
      </div>
      :
      <>
        <nav className="header">
          <div className="buy-link" onClick={handleBuyGuideComponent}>   
            BUY
          </div>
          <div className="networkselector nav-link" > 
              <select 
                value={counter}
                className="network-dropdown"
                onChange={(e) => handleNetworkChange(parseInt(e.target.value, 10))}
              >
                {networkDataArray.map((network, index) => (
                  <option key={index} value={index}>
                    {network.ecosystem}
                  </option>
                ))}
              </select>
            </div>
          <div className="donor-link" onClick={handleDonorComponent}>   
              Donor's Lounge
          </div>
          <div className="nav-link" onClick={handleRoadmapComponent}>   
              Roadmap
          </div>
        </nav>
      </>
      }
    </>
      <div className="button-container">
        <>
          <Connector className="connector" _counter={counter}/>
          {account && 
            <div className="layoutBox"> 
            <NativeBalance />
            </div>
          }
        </>
      </div>
      <div className="main-container" align="center">
        {!component && (
          <>              
            <div className="centerAlign" align="center">
                {summary()}            
                {submitText === null && 
                <div className="" align="center">
                  <div className="title waveanimator header1"> B.R.A.I.N </div>
                    <div className="subtitle waveanimator class1">
                      Big-data Reasoning & Autonomous Intelligence Node on Sonic
                    </div>
                </div>
                }
              
            <br />
            {account && nativeBalance > 0 && 
              <div onClick={loadRobot}>
                <Brain />
              </div>
            } 
            {account && !nativeBalance &&
              <button className="ai-button-red" onClick={playDenied}>       
                <span style={{ color: "hotpink", textShadow: "0 0 5px black"}}> ACCESS DENIED.
                </span>
              </button>
            }
            </div>
            <div className="carousel-container">
              {landingImages.map((src, index) => {
                const total = landingImages.length;
                const theta = (2 * Math.PI * index) / total; // Angle of each image
                const x = radius * Math.cos(theta + (angle * Math.PI) / 180); // X position
                const y = radius * Math.sin(theta + (angle * Math.PI) / 180); // Y position
                return (
                  <img
                    key={index}
                    src={src}
                    alt={`carousel-item-${index}`}
                    className="carousel-item"
                    style={{
                      transform: `translate(${x}px, ${y}px)`,
                      position: "absolute",
                    }}
                    onClick={() => handleSelector(index)} 
                  />
                );
              })}
            </div>
          </>
        )}
        {account && component === "robot" && (
          <div className="robot-container">
            <Robot />
          </div>
        )}
      </div>
    </div>
  );
};

export default Landing;
